/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Crm_Webhook_DescInputs */

const en_settings_crm_webhook_desc = /** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically route leads and orders to external platforms (Zapier, HubSpot, Salesforce).`)
};

const es_settings_crm_webhook_desc = /** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirige automáticamente clientes potenciales y pedidos a plataformas externas (Zapier, HubSpot, Salesforce).`)
};

const fr_settings_crm_webhook_desc = /** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheminez automatiquement les prospects et les commandes vers des plateformes externes (Zapier, HubSpot, Salesforce).`)
};

const de_settings_crm_webhook_desc = /** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leite Leads und Bestellungen automatisch an externe Plattformen weiter (Zapier, HubSpot, Salesforce).`)
};

const id_settings_crm_webhook_desc = /** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rute otomatis prospek dan pesanan ke platform eksternal (Zapier, HubSpot, Salesforce).`)
};

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const ja_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const zh_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const ar_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const it_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const ru_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const pt_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/** @type {(inputs: Settings_Crm_Webhook_DescInputs) => LocalizedString} */
const ko_settings_crm_webhook_desc = en_settings_crm_webhook_desc;

/**
* | output |
* | --- |
* | "Automatically route leads and orders to external platforms (Zapier, HubSpot, Salesforce)." |
*
* @param {Settings_Crm_Webhook_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_crm_webhook_desc = /** @type {((inputs?: Settings_Crm_Webhook_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Crm_Webhook_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_crm_webhook_desc(inputs)
	if (locale === "es") return es_settings_crm_webhook_desc(inputs)
	if (locale === "fr") return fr_settings_crm_webhook_desc(inputs)
	if (locale === "de") return de_settings_crm_webhook_desc(inputs)
	if (locale === "ja") return ja_settings_crm_webhook_desc(inputs)
	if (locale === "zh") return zh_settings_crm_webhook_desc(inputs)
	if (locale === "ar") return ar_settings_crm_webhook_desc(inputs)
	if (locale === "id") return id_settings_crm_webhook_desc(inputs)
	if (locale === "it") return it_settings_crm_webhook_desc(inputs)
	if (locale === "ru") return ru_settings_crm_webhook_desc(inputs)
	if (locale === "pt") return pt_settings_crm_webhook_desc(inputs)
	return ko_settings_crm_webhook_desc(inputs)
});